import { FC, useMemo } from 'react'

import { SelectableButtonsGrid } from '../SelectableButtonsGrid'
import { useTranslation } from 'react-i18next'

interface Props {
  onChange: (value: boolean | undefined) => void
  value: boolean | undefined
  trueDisplayText?: string
  falseDisplayText?: string
  preventUnselect?: boolean
}

/**
 * Simple binary switch abstracted from generic selectable button grid.  
 * Easy handling of yes/no or other binary questions.  
 *   
 * @example <BinaryButtonSwitch value={value} onChange={(value) => setValue(value)} />
 */
export const BinaryButtonSwitch: FC<Props> = ({
  value,
  onChange,
  preventUnselect = false,
  trueDisplayText,
  falseDisplayText,
}) => {

  const { t } = useTranslation(['common'])

  const normalizedValue = useMemo(() => {
    if (value === null || value === undefined) return undefined
    return !!value ? 1 : 0
  }, [value])

  return (
    <SelectableButtonsGrid<0 | 1> values={[
      {
        value: 1,
        displayName: falseDisplayText ?? t('Yes'),
      },
      {
        value: 0,
        displayName: trueDisplayText ?? t('No'),
      },
    ]}
      selectedValue={normalizedValue}
      onSelect={(value) => onChange(!!value)}
      onUnselect={() => onChange(undefined)}
      preventUnselect={preventUnselect}
      activeButtonClickable={!preventUnselect}
    />
  )
}
